export default __webpack_public_path__ + "static/media/placeholder_portfolio02-es-web.30890aae.png";